import { createSlice } from "@reduxjs/toolkit";
import { timeSheetReducer } from "./reducer";
import { initialState } from "./initialState";
import {
  addRegularizeAction,
  addTimeSheetAction,
  deleteTimeSheetAction,
  editTimeSheetAction,
  emailAllUserAttendanceReportAction,
  emailAllUserTimesheetReportAction,
  emailTimesheetClientWiseTimeSheetReportAction,
  emailTimesheetVsSchedulingMonthlyReportAction,
  getAllUserAttendanceReportAction,
  getClientWiseMonthlyTimeSheetReportAction,
  getClientWiseUserTimeSheetReportAction,
  getMonthWiseTimeSheetReportAction,
  getOpenJobChargedHoursTimesheetAction,
  getSingleAttendanceDetailAction,
  getSingleUserAttendanceReportAction,
  getTimeSheetCalendarReportDataAction,
  getTimeSheetDataAction,
  getTimeSheetReportDataAction,
  getTimeSheetStatus,
  getTimeSheetSummaryReportAction,
  getTimeSheetUnfilledReportAction,
  getTimeSheetUserReportAction,
  getTimeSheetVsSchedulingMonthlyReportAction,
  getTimesheetReportHoursForSpecificJobAction,
} from "./actions";
import { TimeSheetType } from "./timeSheetType";

export const timeSheetSlice = createSlice({
  name: "timeSheet",
  initialState,
  reducers: timeSheetReducer,
  extraReducers: {
    [getTimeSheetDataAction.pending.toString()]: (state: TimeSheetType) => ({
      ...state,
      fetching: true,
    }),
    [getTimeSheetDataAction.fulfilled.toString()]: (
      state: TimeSheetType,
      { payload }
    ) => {
      const { success, message, result, status_code, count } = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success: 0,
          error: message,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        fetching: false,
        timeSheetData: result,
        totalTime: result.total_time,
      };
    },
    [getTimeSheetDataAction.rejected.toString()]: (
      state: TimeSheetType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error.message,
    }),
    [addTimeSheetAction.pending.toString()]: (state: TimeSheetType) => ({
      ...state,
      fetching: true,
    }),
    [addTimeSheetAction.fulfilled.toString()]: (
      state: TimeSheetType,
      { payload }
    ) => {
      const { success, message } = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success: 0,
          error: message,
        };
      }
      return {
        ...state,
        fetching: false,
        success,
        message,
      };
    },
    [addTimeSheetAction.rejected.toString()]: (
      state: TimeSheetType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error.message,
    }),
    //  editTimeSheetAction
    [editTimeSheetAction.pending.toString()]: (state: TimeSheetType) => ({
      ...state,
      fetching: true,
    }),
    [editTimeSheetAction.fulfilled.toString()]: (
      state: TimeSheetType,
      { payload }
    ) => {
      const { success, message, status_code } = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success: 0,
          statusCode: status_code,
          error: message,
        };
      }
      return {
        ...state,
        fetching: false,
        success,
        message,
      };
    },
    [editTimeSheetAction.rejected.toString()]: (
      state: TimeSheetType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error.message,
    }),
    [deleteTimeSheetAction.pending.toString()]: (state: TimeSheetType) => ({
      ...state,
      fetching: true,
    }),
    [deleteTimeSheetAction.fulfilled.toString()]: (
      state: TimeSheetType,
      { payload }
    ) => {
      const { success, message, status_code } = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          statusCode: status_code,
          error: message,
        };
      }
      return {
        ...state,
        fetching: false,
        success,
        message,
      };
    },
    [deleteTimeSheetAction.rejected.toString()]: (
      state: TimeSheetType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      error: error.message,
    }),

    //   timeSheet admin report

    [getTimeSheetReportDataAction.pending.toString()]: (
      state: TimeSheetType
    ) => ({
      ...state,
      fetching: true,
    }),
    [getTimeSheetReportDataAction.fulfilled.toString()]: (
      state: TimeSheetType,
      { payload }
    ) => {
      const {
        success,
        message,
        result,
        status_code,
        total_count,
        total_time_difference,
        billable_sum,
        non_billable_sum,
      } = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success: 0,
          error: message,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        fetching: false,
        timeSheetReportDataList: result,
        timeSheetReportTotalCount: total_count,
        statusCode: status_code,
        success,
        reportTotalTime: total_time_difference,
        reportTotalBillableTime: billable_sum,
        reportTotalNonBillableTime: non_billable_sum,
      };
    },
    [getTimeSheetReportDataAction.rejected.toString()]: (
      state: TimeSheetType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error.message,
    }),
    // timesheet user report
    [getTimeSheetUserReportAction.pending.toString()]: (
      state: TimeSheetType
    ) => ({
      ...state,
      fetching: true,
    }),
    [getTimeSheetUserReportAction.fulfilled.toString()]: (
      state: TimeSheetType,
      { payload }
    ) => {
      const {
        success,
        message,
        result,
        status_code,
        total_count,
        total_time_difference = 0,
        billable_sum,
        non_billable_sum,
      } = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success: 0,
          error: message,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        fetching: false,
        timeSheetReportDataList: result,
        timeSheetReportTotalCount: total_count,
        statusCode: status_code,
        // success,
        reportTotalTime: total_time_difference,
        reportTotalBillableTime: billable_sum,
        reportTotalNonBillableTime: non_billable_sum,
      };
    },
    [getTimeSheetUserReportAction.rejected.toString()]: (
      state: TimeSheetType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error.message,
    }),

    // unfilled dates

    [getTimeSheetUnfilledReportAction.pending.toString()]: (
      state: TimeSheetType
    ) => ({
      ...state,
      fetching: true,
    }),
    [getTimeSheetUnfilledReportAction.fulfilled.toString()]: (
      state: TimeSheetType,
      { payload }
    ) => {
      const { success, message, users_with_timesheets, status_code } = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success: 0,
          error: message,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        fetching: false,
        unfilledTimesheetReportList:
          users_with_timesheets[0]?.unfilled_timesheets,
        unfilledTimesheetCount:
          users_with_timesheets[0]?.unfilled_timesheet_count,
        statusCode: status_code,
        // success,
      };
    },
    [getTimeSheetUnfilledReportAction.rejected.toString()]: (
      state: TimeSheetType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error.message,
    }),

    //  report for specific jobs

    [getTimesheetReportHoursForSpecificJobAction.pending.toString()]: (
      state: TimeSheetType
    ) => ({
      ...state,
      fetching: true,
    }),
    [getTimesheetReportHoursForSpecificJobAction.fulfilled.toString()]: (
      state: TimeSheetType,
      { payload }
    ) => {
      const { data, success, message, status_code } = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success: 0,
          error: message,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        success,
        reportForSpecificJobList: data.result,
        reportForSpecificJobTotalCount: data.total_count,
        totalWorkingHoursOnSpecificJob: data.total_work_hours_sum,
      };
    },
    [getTimesheetReportHoursForSpecificJobAction.rejected.toString()]: (
      state: TimeSheetType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error?.message,
    }),
    [emailAllUserTimesheetReportAction.pending.toString()]: (
      state: TimeSheetType
    ) => ({
      ...state,
      fetching: true,
    }),
    [emailAllUserTimesheetReportAction.fulfilled.toString()]: (
      state: TimeSheetType,
      { payload }
    ) => {
      const { success, message, status_code } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          error: message,
          statusCode: status_code,
        };
      }

      return {
        ...state,
        fetching: false,
        success,
        message,
      };
    },
    [emailAllUserTimesheetReportAction.rejected.toString()]: (
      state: TimeSheetType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      error: error?.message,
      success: 0,
    }),

    [getTimeSheetSummaryReportAction.pending.toString()]: (
      state: TimeSheetType
    ) => ({
      ...state,
      fetching: true,
    }),
    [getTimeSheetSummaryReportAction.fulfilled.toString()]: (
      state: TimeSheetType,
      { payload }
    ) => {
      const {
        success,
        message,
        result,
        status_code,
        count,
        users_without_fill_timesheet,
        users_without_fill_timesheet_count,
        total_sums,
      } = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success: 0,
          error: message,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        fetching: false,
        timesheetSummaryReportList: result,
        timsheetSummaryReportTotal: count,
        billableSumTotal: total_sums?.billable_sum_total,
        nonBillableSumTotal: total_sums?.non_billable_sum_total,
        totalHoursSumTotal: total_sums?.total_hours_sum_total,
        employeeWithoutFillTimesheetList: users_without_fill_timesheet,
        employeeWithoutFillTimesheetCount: users_without_fill_timesheet_count,
        statusCode: status_code,
        success,
      };
    },
    [getTimeSheetSummaryReportAction.rejected.toString()]: (
      state: TimeSheetType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error.message,
    }),
    //timesheet calander
    [getTimeSheetCalendarReportDataAction.pending.toString()]: (
      state: TimeSheetType
    ) => ({
      ...state,
      fetching: true,
    }),
    [getTimeSheetCalendarReportDataAction.fulfilled.toString()]: (
      state: TimeSheetType,
      { payload }
    ) => {
      const {
        success,
        message,
        result,
        status_code,
        total_count,
      } = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success: 0,
          error: message,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        fetching: false,
        timeSheetReportCalenderDataList: result,
        statusCode: status_code,
        // success,
      };
    },
    [getTimeSheetCalendarReportDataAction.rejected.toString()]: (
      state: TimeSheetType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error.message,
    }),
    [getAllUserAttendanceReportAction.pending.toString()]: (
      state: TimeSheetType
    ) => ({
      ...state,
      fetching: true,
    }),
    [getAllUserAttendanceReportAction.fulfilled.toString()]: (
      state: TimeSheetType,
      { payload }
    ) => {
      const {
        success,
        message,
        result,
        status_code,
        count,
      } = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success: 0,
          error: message,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        fetching: false,
        allUserAttendanceReportList: result,
        reportListCount:count,
        statusCode: status_code,
        // success,
      };
    },
    [getAllUserAttendanceReportAction.rejected.toString()]: (
      state: TimeSheetType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error.message,
    }),
    [getSingleUserAttendanceReportAction.pending.toString()]: (
      state: TimeSheetType
    ) => ({
      ...state,
      fetching: true,
    }),
    [getSingleUserAttendanceReportAction.fulfilled.toString()]: (
      state: TimeSheetType,
      { payload }
    ) => {
      const {
        success,
        message,
        result,
        status_code,
        count,
      } = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success: 0,
          error: message,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        fetching: false,
        attendanceReportList: result,
        statusCode: status_code,
        reportListCount:count,
        // success,
      };
    },
    [getSingleUserAttendanceReportAction.rejected.toString()]: (
      state: TimeSheetType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error.message,
    }),
    [getSingleAttendanceDetailAction.pending.toString()]: (state: TimeSheetType) => ({
      ...state,
      singleFetching: true
    }),
    [getSingleAttendanceDetailAction.fulfilled.toString()]: (
      state: TimeSheetType,
      { payload }
    ) => {
      const {
        success,
        message,
        result,
        status_code,
        count,
      } = payload;
      if (success === 0) {
        return {
          ...state,
          singleFetching: false,
          success: 0,
          error: message,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        singleFetching: false,
        singleAttendanceDetail: result,
        statusCode: status_code
      };
    },
    [getSingleAttendanceDetailAction.rejected.toString()]: (
      state: TimeSheetType,
      { error }
    ) => ({
      ...state,
      singleFetching: false,
      success: 0,
      error: error.message,
    }),
    [emailAllUserAttendanceReportAction.pending.toString()]: (
      state: TimeSheetType
    ) => ({
      ...state,
      // fetching: true,
    }),
    [emailAllUserAttendanceReportAction.fulfilled.toString()]: (
      state: TimeSheetType,
      { payload }
    ) => {
      const { success, message, status_code } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          error: message,
          statusCode: status_code,
        };
      }

      return {
        ...state,
        fetching: false,
        success,
        message,
      };
    },
    [emailAllUserAttendanceReportAction.rejected.toString()]: (
      state: TimeSheetType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      error: error?.message,
      success: 0,
    }),
    [getTimeSheetVsSchedulingMonthlyReportAction.pending.toString()]: (
      state: TimeSheetType
    ) => ({
      ...state,
      fetching: true,
    }),
    [getTimeSheetVsSchedulingMonthlyReportAction.fulfilled.toString()]: (
      state: TimeSheetType,
      { payload }
    ) => {
      const {
        success,
        message,
        result,
        status_code,
        total_count,
      } = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success: 0,
          error: message,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        fetching: false,
        timesheetVsSchedulingMonthlyList: result,
        timesheetVsSchedulingMonthlyTotalCount: total_count,
        statusCode: status_code,
        success,
      };
    },
    [getTimeSheetVsSchedulingMonthlyReportAction.rejected.toString()]: (
      state: TimeSheetType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error.message,
    }),

    [emailTimesheetVsSchedulingMonthlyReportAction.pending.toString()]: (
      state: TimeSheetType
    ) => ({
      ...state,
      // fetching: true,
    }),
    [emailTimesheetVsSchedulingMonthlyReportAction.fulfilled.toString()]: (
      state: TimeSheetType,
      { payload }
    ) => {
      const { success, message, status_code } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          error: message,
          statusCode: status_code,
        };
      }

      return {
        ...state,
        fetching: false,
        success,
        message,
      };
    },
    [emailTimesheetVsSchedulingMonthlyReportAction.rejected.toString()]: (
      state: TimeSheetType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      error: error?.message,
      success: 0,
    }),
    [emailTimesheetClientWiseTimeSheetReportAction.pending.toString()]: (
      state: TimeSheetType
    ) => ({
      ...state,
      // fetching: true,
    }),
    [emailTimesheetClientWiseTimeSheetReportAction.fulfilled.toString()]: (
      state: TimeSheetType,
      { payload }
    ) => {
      const { success, message, status_code } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          error: message,
          statusCode: status_code,
        };
      }

      return {
        ...state,
        fetching: false,
        success,
        message,
      };
    },
    [emailTimesheetClientWiseTimeSheetReportAction.rejected.toString()]: (
      state: TimeSheetType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      error: error?.message,
      success: 0,
    }),
    [getClientWiseUserTimeSheetReportAction.pending.toString()]: (
      state: TimeSheetType
    ) => ({
      ...state,
      fetching: true,
    }),
    [getClientWiseUserTimeSheetReportAction.fulfilled.toString()]: (
      state: TimeSheetType,
      { payload }
    ) => {
      const {
        success,
        message,
        result,
        status_code,
      } = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success: 0,
          error: message,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        fetching: false,
        clientWiseUserTimeSheetList: result,
        statusCode: status_code,
        success,
      };
    },
    [getClientWiseUserTimeSheetReportAction.rejected.toString()]: (
      state: TimeSheetType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error.message,
    }),

    [addRegularizeAction.pending.toString()]: (
      state: TimeSheetType
    ) => ({
      ...state,
      fetching: true,
    }),
    [addRegularizeAction.fulfilled.toString()]: (
      state: TimeSheetType,
      { payload }
    ) => {
      const { success, message, status_code } = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success: 0,
          error: message,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        success,
        message
      };
    },
    [addRegularizeAction.rejected.toString()]: (
      state: TimeSheetType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error.message,
    }),
    [getClientWiseMonthlyTimeSheetReportAction.pending.toString()]: (
      state: TimeSheetType
    ) => ({
      ...state,
      fetching: true,
    }),
    [getClientWiseMonthlyTimeSheetReportAction.fulfilled.toString()]: (
      state: TimeSheetType,
      { payload }
    ) => {
      const {
        success,
        message,
        result,
        status_code,
      } = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success: 0,
          error: message,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        fetching: false,
        clientWiseMonthlyTimesheetReportList: result?.data,
        clientWiseMonthlyReportCount:result?.count,
        timesheetReportTargetHours:result?.client_details?.target_hours,
        statusCode: status_code,
        success,
      };
    },
    [getClientWiseMonthlyTimeSheetReportAction.rejected.toString()]: (
      state: TimeSheetType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error.message,
    }),
    [getMonthWiseTimeSheetReportAction.pending.toString()]: (
      state: TimeSheetType
    ) => ({
      ...state,
      fetching: true,
    }),
    [getMonthWiseTimeSheetReportAction.fulfilled.toString()]: (
      state: TimeSheetType,
      { payload }
    ) => {
      const {
        success,
        message,
        result,
        status_code,
      } = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success: 0,
          error: message,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        fetching: false,
        monthWiseTimesheetReportList: result?.data,
        monthWiseTimesheetReportTotalCount:result?.count,
        statusCode: status_code,
        success,
      };
    },
    [getMonthWiseTimeSheetReportAction.rejected.toString()]: (
      state: TimeSheetType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error.message,
    }),

    [getOpenJobChargedHoursTimesheetAction.pending.toString()]: (
      state: TimeSheetType
    ) => ({
      ...state,
      fetching: true,
    }),
    [getOpenJobChargedHoursTimesheetAction.fulfilled.toString()]: (
      state: TimeSheetType,
      { payload }
    ) => {
      const { success, status_code, message,sum_of_total_hours, result } = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          success,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        success,
        message,
        openJobChargedHoursTimesheetTotalSum:sum_of_total_hours,
        openJobChargedHoursTimesheetList:result
      };
    },
    [getOpenJobChargedHoursTimesheetAction.rejected.toString()]: (
      state: TimeSheetType,
      { error }
    ) => ({
      ...state,
      success: 0,
      error: error?.message,
      fetching: false,
    }),


    [getTimeSheetStatus.pending.toString()]: (
      state: TimeSheetType
    ) => ({
      ...state,
      fetching: true,
    }),
    [getTimeSheetStatus.fulfilled.toString()]: (
      state: TimeSheetType,
      { payload }
    ) => {
      const { success, status_code, message, result } = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          success,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        fetching: false,
        enableBackdatedTimesheetEntry: result.enable_backdated_timesheet_entry,
      };
    },
    [getTimeSheetStatus.rejected.toString()]: (
      state: TimeSheetType,
      { error }
    ) => ({
      ...state,
      success: 0,
      error: error?.message,
      fetching: false,
    }),
  },
});

export const {
  resetTimeSheetSuccess,
  resetTimeSheetError,
  resetTimeSheetMessage,
  resetTimeSheetStatusCode,
  resetTimeSheetTotalTime,
  resetTimeSheetListing,
  resetTimeSheetReportListing,
  resetTimeSheetReportTotalCount,
  resetUserTimeSheetReportSuccess,
  resetUserViewTimeSheetReportStatusCode,
  resetUserViewTimeSheetReportError,
  resetUserViewTimeSheetReportMessage,
  resetTimeSheetReportTotalTime,
  resetUnfilledTimesheetCount,
  resetUnfilledTimesheetReportList,
  resetReportForSpecificJobList,
  resetReportForSpecificJobTotalCount,
  resetTotalWorkingHoursOnSpecificJob,
  resetTimeSheetReportBillableTotalTime,
  resetTimeSheetReportNonBillableTotalTime,
  resetTimeSheetSummaryReportListing,
  resetTimeSheetSummaryReportTotalCount,
  resetBillableSumTotal,
  resetNonBillableSumTotal,
  resetTotalHoursSumTotal,
  resetEmployeeWithoutFillTimesheetList,
  resetEmployeeWithoutFillTimesheetCount,
  resetTimeSheetReportCalenderDataList,
  resetAllUserAttendanceReportList,
  resetSingleAttendaceReportList,
  resetSingleAttendanceDetail,
  resetAttendanceReportListCount,
  resetTimesheetVsSchedulingMonthlyList,
  resetTimesheetVsSchedulingMonthlyTotalCount,
  resetClientWiseUserTimeSheetList,
  resetClientWiseMonthlyReportCount,
  resetClientWiseMonthlyTimesheetReportList,
  resetMonthWiseTimesheetReportTotalCount,
  resetMonthWiseTimesheetReportList,
  resetTimesheetReportTargetHours,
  resetOpenJobChargedHoursTimesheetList,
  resetOpenJobChargedHoursTimesheetTotalSum,
  resetEnableBackdatedTimesheetEntry

} = timeSheetSlice.actions;
